import { Button, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import React, { useEffect, useState } from 'react';
import {
  vendorAttributeList,
  VENDOR_EDIT_CURTAIN,
  VENDOR_EDIT_DDK,
  VENDOR_EDIT_DND,
  VENDOR_EDIT_DOOR_CAMERA,
  VENDOR_EDIT_DOOR_LOCK,
  VENDOR_EDIT_LIGHT,
  VENDOR_EDIT_MMR,
  VENDOR_EDIT_SCENE,
  VENDOR_EDIT_THERMO,
  VENDOR_VIEW_CURTAIN,
  VENDOR_VIEW_DDK,
  VENDOR_VIEW_DND,
  VENDOR_VIEW_DOOR_CAMERA,
  VENDOR_VIEW_DOOR_LOCK,
  VENDOR_VIEW_LIGHT,
  VENDOR_VIEW_MMR,
  VENDOR_VIEW_SCENE,
  VENDOR_VIEW_THERMO,
} from '../../../../../constants/VendorConst';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { formatDateString } from '../../../../../utils/commonUtils';
import './VendorView.scss';

const VendorView = (props) => {
  const { type, data, onViewToggle, toggleDrawer, allVendors } = props;
  const [selectedVendor, setSelectedVendor] = useState(data);
  const loading = false;
  const [vendorAttribute, setVendorAttribute] = useState([]);
  const [searchText, setSearchText] = useState('');

  const selectVendorType = (type) => {
    switch (type) {
      case VENDOR_VIEW_LIGHT:
        return { name: 'Light Configuration', action: VENDOR_EDIT_LIGHT };
      case VENDOR_VIEW_SCENE:
        return { name: 'Scene Configuration', action: VENDOR_EDIT_SCENE };
      case VENDOR_VIEW_CURTAIN:
        return { name: 'Curtain Configuration', action: VENDOR_EDIT_CURTAIN };
      case VENDOR_VIEW_THERMO:
        return { name: 'Thermostat Configuration', action: VENDOR_EDIT_THERMO };
      case VENDOR_VIEW_DDK:
        return {
          name: 'Digital Door Key Configuration',
          action: VENDOR_EDIT_DDK,
        };
      case VENDOR_VIEW_DOOR_LOCK:
        return {
          name: 'Door Lock Configuration',
          action: VENDOR_EDIT_DOOR_LOCK,
        };
      case VENDOR_VIEW_DOOR_CAMERA:
        return {
          name: 'Door Camera Configuration',
          action: VENDOR_EDIT_DOOR_CAMERA,
        };
      case VENDOR_VIEW_DND:
        return { name: 'DND Configuration', action: VENDOR_EDIT_DND };
      case VENDOR_VIEW_MMR:
        return { name: 'MMR Configuration', action: VENDOR_EDIT_MMR };
      default:
        break;
    }
  };

  const onOpenDrawer = (event, type) => {
    event?.stopPropagation();
    toggleDrawer(type, true, selectedVendor);
  };

  const handleSearchText = (userValue) => {
    setSearchText(userValue);

    if (!data?.enabledAttributes) {
      setVendorAttribute([]);
      return;
    }

    const allAttributesCopy = [...data?.enabledAttributes];

    if (userValue === '' || userValue?.trim() === '') {
      setVendorAttribute(allAttributesCopy);
    } else {
      const temporaryList = allAttributesCopy?.filter((attributeValue) => {
        const currItem = vendorAttributeList?.find((attr) => attr?.value === attributeValue);
        const attributeName = currItem?.name || attributeValue || '';

        const searchInValue = attributeValue?.toLowerCase()?.includes(userValue?.toLowerCase());
        const searchInName = attributeName?.toLowerCase()?.includes(userValue?.toLowerCase());

        return searchInValue || searchInName;
      });

      setVendorAttribute(temporaryList);
    }
  };

  useEffect(() => {
    setVendorAttribute(selectedVendor?.enabledAttributes || []);
  }, [selectedVendor]);

  useEffect(() => {
    setSelectedVendor(data);
  }, [data]);

  useEffect(() => {
    allVendors?.forEach((item) => {
      if (item?.id === data?.id) {
        const dataCopy = { ...data };
        dataCopy.name = item?.name;
        dataCopy.enabledAttributes = item?.enabledAttributes;
        setSelectedVendor(dataCopy);
      }
    });
  }, [toggleDrawer]);

  return (
    <>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : (
        selectedVendor && (
          <div className='container mt-3 detail-view'>
            <div className='mt-5 row mx-0'>
              <div className='col-md-6 px-0 d-flex align-item-center'>
                <Button
                  variant='text'
                  color='secondary'
                  size='small'
                  startIcon={<ArrowBack />}
                  onClick={(e) => onViewToggle(null, false, null)}
                  className='me-2'
                >
                  Back
                </Button>
                <span className='page-title'>{selectedVendor?.name}</span>
              </div>
            </div>
            <div className='mt-3 row mx-0'>
              <div className='col-md-6 px-0 d-flex align-item-center'>
                <div className='d-flex flex-column'>
                  <p className='vendor-view-page-type mb-0 page-title-secondary'>
                    {selectVendorType(type)?.name}
                  </p>
                  <p className='vendor-view-last-modified mb-0'>
                    Last updated: {formatDateString(data?.updatedAt ?? data?.createdAt) ?? ''}
                  </p>
                </div>
              </div>
              <div className='col-md-6 d-flex justify-content-end my-2'>
                <Button
                  variant='outlined'
                  color='primary'
                  size='small'
                  onClick={(e) => onOpenDrawer(e, selectVendorType(type)?.action)}
                >
                  Edit
                </Button>
              </div>
            </div>
            <div className='card shadow mt-4 mb-4 h-100'>
              <div className='row mx-4 mt-4'>
                <div className='col-md-6 d-flex align-items-end'>
                  <span className='page-title-secondary'>Details</span>
                </div>
                <div className='col-md-6'>
                  <div className='col-md-12 d-flex justify-content-end p-0'>
                    <div className='vendor-view-search-wrapper w-100'>
                      <SearchBar
                        setSearchText={handleSearchText}
                        searchText={searchText}
                        displayAddOrEdit='hide'
                        onOpenDrawer={() => {}}
                        actionMenuItems={[]}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mx-4'>
                <div className='vendor-view-content mt-4'>
                  {vendorAttribute?.map((item, index) => {
                    let currItem = vendorAttributeList?.find((attr) => attr?.value === item);
                    return (
                      <div
                        key={index}
                        className='px-3 d-flex align-items-center vendor-view-attribute gx-2'
                      >
                        {currItem?.name ?? 'undefined'}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default VendorView;
